import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJActionHeadshotGenerator from '../../../../redux/action/FJActionHeadshotGenerator';
import { FJCategorySelector } from '../view/steps';

const FJCategorySelectorContainer = () => {
    const dispatch = useDispatch();
    const selectedCategory = useSelector(state => state.headshotGenerator.selectedCategory);
    const selectedCategoryKey = useSelector(state => state.headshotGenerator.selectedCategoryKey);

    const handleCategoryChange = useCallback(
        category => {
            dispatch(FJActionHeadshotGenerator.setCategoryAction(category));
        },
        [dispatch],
    );

    return (
        <FJCategorySelector
            selectedCategory={selectedCategory}
            onCategoryChange={handleCategoryChange}
            selectedCategoryKey={selectedCategoryKey}
        />
    );
};

export default FJCategorySelectorContainer;
